import type { Chain } from 'viem';

type BannerSettings = {
  error?: { title: string; description: string };
  newChain?: Chain;
};

// Update this key when you want to show a new banner. This will reset
// the dismissed state and show the banner to all users again.
export const BANNER_STORAGE_KEY = `ink-launch-2026`;

// Update these values to display the desired banner to users.
// E.g. error: { title: 'AWS Outage', description: 'Matcha services impacted' },
export const BANNER_SETTINGS: BannerSettings = {
  error: undefined,
  newChain: undefined,
};

export const SHOW_BANNER_DEFAULT =
  BANNER_SETTINGS.error != null || BANNER_SETTINGS.newChain != null;
